export default __webpack_public_path__ + "static/media/Mask Group 67.21c622f4.png";